export default (range) => ({
    key: range.startKey,
    offset: range.startOffset,
});
